"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var icon_1 = require("../../constants/img/icon");
var Brand;
(function (Brand) {
    Brand["FLO"] = "FLO";
    Brand["URO"] = "URO";
    Brand["MENO"] = "MENO";
    Brand["GOGO"] = "GOGO";
    Brand["WILLO"] = "WILLO";
    Brand["PREGGO"] = "PREGGO";
})(Brand || (Brand = {}));
// Created to take care of the design aspect of MenuListItem
var MenuListItem = function (_a) {
    var menuItem = _a.menuItem, onClick = _a.onClick, otherNav = _a.otherNav;
    // Split title to "URO" and "Vaginal Probiotic" by "|" so we can style them differently
    var splitTitle = menuItem.title.split('|').map(function (elem) {
        return elem.trim();
    });
    // If the first part of title is within Brand,
    // assign them to CSS name as modifier
    var classModifier = Object.values(Brand).includes(splitTitle[0])
        ? "menu-item__main--".concat(splitTitle[0].toLowerCase())
        : '';
    return ((0, preact_1.h)("button", { class: 'preact-btn menu-item', onClick: onClick },
        (0, preact_1.h)("p", { class: "menu-item__text" },
            (0, preact_1.h)("span", { class: "menu-item__main ".concat(classModifier) }, splitTitle[0]),
            ' ',
            splitTitle[1] && (0, preact_1.h)("span", { class: "menu-item__sub" }, splitTitle[1])),
        !otherNav && (0, preact_1.h)("img", { class: "menu-item__arrow", src: icon_1.RIGHT_ARROW, alt: ">" })));
};
exports.default = MenuListItem;
